'use client';

import { forwardRef } from 'react';
import MuiAlert, { type AlertProps as MuiAlertProps } from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';

export interface AlertProps extends MuiAlertProps {
  title?: string;
}

export const Alert = forwardRef<HTMLDivElement, AlertProps>(({ title, children, ...props }, ref) => {
  return (
    <MuiAlert ref={ref} {...props}>
      {title && <AlertTitle>{title}</AlertTitle>}
      {children}
    </MuiAlert>
  );
});

Alert.displayName = 'Alert';
